import Form from '../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../utils/analytics-helper';

export default class PasswordValidateOTPView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.password-validate-otp-view');
        this.correlationText = this.el.querySelector('.correlationText');
        this.otpInput = this.el.querySelector('input[name="otp"]');
        this.otpIdInput = this.el.querySelector('input[name="otpId"]');
        this.correlationInput = this.el.querySelector('input[name="correlation"]');
        this.emailInput = this.el.querySelector('input[name="email"]');
        this.form = new Form(this.parent.el.querySelector('.password-validate-otp-form'), {
            onSubmit: this.onSubmit.bind(this),
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.resendOtp = this.el.querySelector('.resend-otp');
        this.bind();
    }

    bind() {
        this.resendOtp.addEventListener('click', (e) => {
            e.preventDefault();
            this.parent.show({ view: 'password-validate-otp'});
            this.parent.views['password-send-otp'].submit({
                onSuccess: () => {
                    this.parent.show({ view: 'password-validate-otp' , message: this.form.el.dataset.resendOtpMessage, messageType: 'success'});
                }
            });
        });
    }

    onSubmit() {
        this.parent.show({ view: 'password-validate-otp'});
    }

    onSuccess(result) {
        if (result.exists) {
            this.parent.show({ view: 'password-reset' });
        } else {
            this.parent.show({ view: 'register', message: this.form.el.dataset.noAccountError });
        }

        this.analyticsPush();
    }

    onError(result) {
        this.form.showError();
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    populate(data) {
        this.otpInput.value = '';
        this.correlationText.textContent = data.correlation;
        this.otpIdInput.value = data.otpId;
        this.correlationInput.value = data.correlation;
        this.emailInput.value = data.email;
        this.form.hideError();
    }

    back() {
        this.parent.show({ view: 'password-send-otp' });
    }

    analyticsPush() {
        AnalyticsHelper.push({
            event:'my_account',
            eventCategory:'my account',
            eventAction:'reset password OTP submit',
            eventLabel:`${dataLayer[0].productCategory}|My account|submit|internal|#`,
            actionType:'reset password OTP submit',
            businessUnit: dataLayer[0].productCategory,
            moduleName:'My account',
            clickText:'submit',
            clickType:'internal', 
            destinationURL:'#'
        });
    }
}
